import type { ReactElement } from "react";

import { SWReactCountryIcons } from "@similarweb/icons";
import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { ICountryObject } from "app/services/CountryService";

import { getCountryOptionPadding } from "./rowIndent";

export type CountryOptionProps = {
    countryItem: ICountryObject;
    selectedCodes: ReadonlySet<number>;
    dataAutomation: string;
    onSelectCountry: () => void;
    optionId: string;
    depth?: number;
};

export const CountryOption = ({
    countryItem,
    selectedCodes,
    dataAutomation,
    onSelectCountry,
    optionId,
    depth = 1,
}: CountryOptionProps): ReactElement => (
    <Combobox.Option
        id={optionId}
        textValue={countryItem.text}
        onClick={onSelectCountry}
        data-automation={dataAutomation}
    >
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="8px"
            width="100%"
            padding={getCountryOptionPadding(depth)}
        >
            <Flex
                alignItems="center"
                gap="8px"
                flex="1"
                minWidth={0}
            >
                <SWReactCountryIcons
                    countryCode={countryItem.id}
                    size="xs"
                />
                <Combobox.OptionLabel>{countryItem.text}</Combobox.OptionLabel>
            </Flex>
            <Combobox.OptionCheckbox isChecked={selectedCodes.has(countryItem.id)} />
        </Flex>
    </Combobox.Option>
);
